export default __webpack_public_path__ + "static/media/preloader.4e7be108.gif";